import { render, staticRenderFns } from "./Expedientes.vue?vue&type=template&id=a4c2fb26&scoped=true&"
import script from "./Expedientes.vue?vue&type=script&lang=js&"
export * from "./Expedientes.vue?vue&type=script&lang=js&"
import style1 from "./Expedientes.vue?vue&type=style&index=1&id=a4c2fb26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c2fb26",
  null
  
)

export default component.exports